import React from 'react'
import { Link } from 'react-router-dom'
import Constant from '../../Constant'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import 'react-toggle/style.css' // for ES6 modules
import Toggle from 'react-toggle'
import axios from 'axios'

class PaymentTypeList extends React.Component {
  state = {}
  componentDidMount() {
    this.getPaymentDetails()
  }
  getPaymentDetails = async () => {
    var that = this
    await axios
      .get(Constant.getAPI() + `/payment/get-payment-methods`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          that.setState({
            Payment_data: res.data.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }
  handleStatusChange = async (id, active) => {
    var data = {
      PaymentMethodId: id,
      isActive: active,
    }
    await axios
      .post(Constant.getAPI() + '/payment/update-method-status', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Updated !', 'Status has been Changed', 'success')
          this.getPaymentDetails()
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }
  render() {
    const columns = [
      {
        name: 'PaymentMethodId',
        label: 'PaymentMethodID',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'ImageUrl',
        label: 'Image',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (ImageUrl) => {
            return (
              <>
                {ImageUrl?.includes('https://') ? (
                  <img
                    src={ImageUrl}
                    className="img-fluid img-40"
                    alt="img"
                    onError={(event) => {
                      event.currentTarget.src = './assets/images/no_image.png'
                    }}
                  />
                ) : (
                  <img
                    src={Constant.getImage() + ImageUrl}
                    className="img-fluid img-40"
                    alt="img"
                    onError={(event) => {
                      event.currentTarget.src = './assets/images/no_image.png'
                    }}
                  />
                )}
              </>
            )
          },
        },
      },
      {
        name: 'PaymentMethod_en',
        label: 'PaymentType Name : English',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'PaymentMethod_ar',
        label: 'PaymentType Name : Arabic',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'CurrencyIso',
        label: 'Currency',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'isActive',
        label: 'Status',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (active, tableMeta) => {
            return (
              <Toggle
                checked={active === true ? true : false}
                value={active}
                onChange={this.handleStatusChange.bind(this, tableMeta.rowData[0], !active)}
              />
            )
          },
        },
      },
      // {
      //   name: "id",
      //   label: "Action",
      //   options: {
      //     filter: true,
      //     sort: true,
      //     customBodyRender: (id, tableMeta) => {
      //       return (
      //         <div>
      //           <Link
      //             to={"/payment-type/add/" + id}
      //             className="m-r-15 text-muted"
      //             data-toggle="tooltip"
      //             data-placement="top"
      //             title=""
      //             data-original-title="Edit"
      //           >
      //             <i className="f-20 icofont icofont-ui-edit text-custom"></i>
      //           </Link>
      //           <span
      //             onClick={this.deletePaymentType.bind(this, id)}
      //             className="m-r-15 text-muted"
      //             data-toggle="tooltip"
      //             data-placement="top"
      //             title=""
      //             data-original-title="Delete"
      //           >
      //             <i className="f-20 icofont icofont-delete-alt text-danger"></i>{" "}
      //           </span>
      //         </div>
      //       );
      //     },
      //   },
      // },
    ]

    const options = {
      filterType: 'dropdown',
      viewColumns: false,
      print: false,
      download: false,
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isSaving ? 'Loading data..!' : 'Sorry, No PaymentType Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }
    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>PaymentType List</h4>
                    </div>
                  </div>
                  {/* {localStorage.getItem('q8_mall_ad_role') !== "shop"
                    ? */}
                  {/* <Link to="/payment-type/add" className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger" data-modal="modal-13"> <i className="icofont icofont-plus m-r-5"></i> Add PaymentType </Link> */}
                  {/* :
                  } */}
                  {/* <Link
                    to="/"
                    className="btn btn-sm btn-outline-dark waves-effect waves-light f-right d-inline-block md-trigger mx-3"
                    data-modal="modal-13"
                  >
                    {" "}
                    <i className="icofont icofont-arrow-left m-r-5"></i> Back{" "}
                  </Link> */}
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">PaymentType List</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        <MUIDataTable
                          title={'PaymentType List'}
                          className="table-responsive"
                          data={this.state.Payment_data}
                          columns={columns}
                          options={options}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default PaymentTypeList
